import { HEALTH, healthOf } from "../lib/domain.js";

/* Three states and a text box, in that order: on a long board the question
   is nearly always "what needs attention" and only then "where is Kalyan
   Ground". The states are toggles rather than a segmented control because
   the most useful query of all — at risk *and* critical — is two of them
   at once, which a one-of-three control cannot express.
 *
 * Nothing selected means the whole board. That reads as an unfiltered view
 * rather than as a filter that happens to match everything, so the bar
 * stays silent until someone actually narrows it. */

export const HEALTH_KEYS = ["healthy", "at-risk", "critical"];

/* Search covers the two things written on the face of a tile — the
   playground and whoever owns it. Not the index: nobody looks for "07". */
export function matchesFilter(pg, q, states) {
  if (states.length && !states.includes(healthOf(pg))) return false;
  const needle = q.trim().toLowerCase();
  if (!needle) return true;
  return (
    pg.name.toLowerCase().includes(needle) ||
    (pg.owner || "").toLowerCase().includes(needle)
  );
}

export function BoardFilter({
  q,
  states,
  onQuery,
  onToggle,
  onClear,
  shown,
  total,
  onAdd,
  adding,
}) {
  const narrowed = Boolean(q.trim()) || states.length > 0;

  return (
    <div className="filterbar">
      <input
        className="in filterq"
        type="search"
        value={q}
        onChange={(e) => onQuery(e.target.value)}
        placeholder="Search a playground or an owner…"
        aria-label="Search playgrounds by name or owner"
      />

      <div className="chipset" role="group" aria-label="Filter by health">
        {HEALTH_KEYS.map((key) => {
          const on = states.includes(key);
          return (
            <button
              key={key}
              type="button"
              className={"fchip " + HEALTH[key].tone + (on ? " on" : "")}
              aria-pressed={on}
              onClick={() => onToggle(key)}
            >
              <i className="dot" aria-hidden="true" />
              {HEALTH[key].label}
            </button>
          );
        })}
      </div>

      {/* The end of the bar: what the filter left, then the way to add to
          it. Both sit right so the pair holds its place as the search box
          and the chips change width. */}
      <div className="filterend">
        {/* The rail above counts the whole board; this counts what is left
            of it, and only once that is a different number. */}
        {narrowed && (
          <span className="filtercount" aria-live="polite">
            {shown} of {total}
          </span>
        )}
        {narrowed && (
          <button className="btn btn-sm" type="button" onClick={onClear}>
            Clear
          </button>
        )}
        {onAdd && (
          <button
            className="btn btn-sm btn-solid"
            type="button"
            onClick={onAdd}
            disabled={adding}
          >
            <span className="plus" aria-hidden="true">
              +
            </span>
            {adding ? "Adding…" : "Add playground"}
          </button>
        )}
      </div>
    </div>
  );
}
